<template>
    <div>
        <div style="display: flex; align-items: center; gap: 4px; justify-content: space-between;">
            <div style="display: flex; align-items: center; gap: 8px;width:100%;">
                <div @click.stop="$Util.showProfile(memberList.creator_idx, memberList.creator_type, '', memberList.creator.is_coach)">
                    <ProfileImage style="width: 40px; height: 40px;" :image-path="memberList.creator && memberList.creator.image_path ? memberList.creator.image_path : null" :is-show-border="false" />
                </div>
                <div style="flex:1;">
                    <div v-if="memberList.join_tag" style="color: #808080; font-size:12px; font-weight:500;">{{ memberList.join_tag.split(',')[0] }}</div>
                    <div style="display: flex; gap: 5px; margin-bottom: 6px; align-items: center; margin-top:7px;">
                        <div style="font-weight: 700; font-size: 14px;  white-space: nowrap;">{{ memberList.creator ? memberList.creator.nic_name : '' }}</div>
                        <div v-if="memberList.creator.is_coach === '1'">
                            <img v-if="memberList.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </div>
                        <div style="font-size: 14px; font-weight: 700; color: var(--color-main);" v-else>
                            <DivisionPositionText :position="memberList.creator.position" :positionProAbility="memberList.creator.position_pro_ability"></DivisionPositionText>
                        </div>
                    </div>
                </div>
                <div v-if="memberList.last_chat_contents" style="font-size:12px; font-weight:500; color:#808080; align-self: flex-end; margin-bottom:7px;">{{ memberList.last_chat_contents.insert_date | agoDateStr }}</div>
            </div>
            <!--<div class="hide_scroll" style="display: flex; gap: 8px; overflow-x: scroll;">-->
            <!--<div v-if="memberList.join_tag" style="padding: 4px 12px; background-color: #f5f5f5; border-radius: 16px; font-size: 12px; font-weight: 700; line-height: 24px; flex-shrink: 0">{{ memberList.join_tag.split(',')[0] }}</div>-->
            <!--<div v-if="memberList.age" style="padding: 4px 12px; background-color: #f5f5f5; border-radius: 16px; font-size: 12px; font-weight: 700; line-height: 24px; flex-shrink: 0">{{ memberList.age.split(',')[0] }}</div>-->
            <!--</div>-->
        </div>
        <InteractionOfScale>
            <div @click="joinMemberTalkConfirm(memberList)" class="guide_box" style="transition: all 0.5s;">
                <div style="display:flex; gap:10px;">
                    <div style=" width:118px; height:118px; border-radius:10px; overflow: hidden;">
                        <img v-if="memberList.image_path" :src="$resourcePath + memberList.image_path" style="width:100%; height:100%; object-fit: cover;">
                        <div v-else style="background-color:blue;width:100%; height:100%;"></div>
                    </div>
                    <div style="flex:1;">
                        <div class="contents_replace_js" style="font-weight: 700; line-height: 23px; margin-bottom: 4px">{{ memberList.title }}</div>
                        <div class="contents_replace_js" style="line-height: 20px; font-weight: 500; font-size: 14px">{{ memberList.introduce }}</div>
                    </div>
                </div>

                <div style="display:flex;margin-top: 9px;">
                    <div style="flex:1;">
                        <div class="hide_scroll" style="display: flex; gap: 8px; overflow-x: scroll;">
                            <div v-if="memberList.join_tag" style="padding: 4px 12px; background-color: white; border-radius: 16px; font-size: 12px; font-weight: 700; line-height: 24px; flex-shrink: 0">{{ memberList.join_tag.split(',')[0] }}</div>
                            <div v-if="memberList.age" style="padding: 4px 12px; background-color: white; border-radius: 16px; font-size: 12px; font-weight: 700; line-height: 24px; flex-shrink: 0">{{ memberList.age.split(',')[0] }}</div>
                        </div>
                    </div>
                    <div style="">
                        <div style="display: flex; align-items: center; justify-content: space-between; margin-top:6px;">
                            <div style="display: flex;">
                                <div v-for="(each, i) in memberList.join_members" :key="i" class="see_my_profile" :style="{ marginLeft: i !== 0 ? '-6px' : '', display: i >= 5 ? 'none' : '' }">
                                    <ProfileImage :image-path="each.image_path" :is-show-border="true" />
                                    <div v-if="i === 4" class="profile_circle"></div>
                                    <img v-if="i === 4" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 14px; height: 4px" :src="require('@/assets/more_list.png')" alt="" />
                                </div>
                                <div style="display: flex; align-items: center; justify-content: center; margin-left: 6px;">
                                    <div style="font-weight: 700; font-size: 10px; color: #606060;">{{ memberList.cur_cnt }}명 참여중</div>
                                </div>
                            </div>
                            <!-- <div v-if="memberList.last_chat_contents" style="font-weight: 500; font-size: 10px;">{{ memberList.last_chat_contents.insert_date | agoDateStr }}</div>
                        <div v-else style="font-weight: 500; font-size: 10px;">대화없음</div> -->
                        </div>
                    </div>
                </div>

                <transition name="fade">
                    <div v-if="showFormation" style="margin-top: 12px;">
                        <div class="h_scroll_wrap">
                            <div class="tag_item" v-if="memberList.join_region">{{ memberList.join_region }}</div>
                            <div class="tag_item">{{ memberList.join_way === JOIN_WAY.ANYBODY ? '누구나 참여가능' : '승인시 참여가능' }}</div>
                            <div class="tag_item" v-if="memberList.age">{{ memberList.age === '누구나 참여 가능' ? '제한 없음' : memberList.age }}</div>
                            <div v-for="each, i in join_tag" :key="i" class="tag_item">{{ each }}</div>
                        </div>
                        <div v-if="(memberList.gps_latitude && memberList.gps_latitude != 0)" style="margin-top: 12px; border-radius: 12px; position:relative;">
                            <swiper class="initial_start" ref="filterSwiper" :options="swiperOption" role="tablist">
                                <swiper-slide role="tab" v-if="memberList.gps_latitude && memberList.gps_latitude != 0" style="padding-bottom:115.7%;">
                                    <div style="height: 100%; width:100%; background-color: white; border-radius: 12px; position:absolute;" :id="'member_list_' + index"></div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-pagination paging_text" slot="pagination" style="width:100%; font-size:12px; display:inline-block;"></div>
                            <div style="height:20px;"></div>
                        </div>
                        <div style="display: flex; margin-top: 16px; gap: 8px;" v-if="!$GlobalStore.checkIsMe(memberList.creator_idx, memberList.creator_type)">
                            <div style="flex-basis: 80px; background-color: #fff; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 12px; height: 52px; " @click.stop="toggleLike(memberList.idx); $Util.sendEventClick('조인_조인디테일_좋아요')">
                                <IconHeart :fill="like_yn ? 'var(--color-main)' : '#d9d9d9'" :width="'21px'"></IconHeart>
                                <div :style="{ color: like_yn ? 'var(--color-main)' : '#d9d9d9' }" style="font-size: 14px; font-weight: 700;">{{ parseInt(memberList.like_cnt) >= 100 ? '99+' : memberList.like_cnt }}</div>
                            </div>
                            <div v-if="memberList.is_me_joined" style="flex: 1; background-color: #fff; display: flex; justify-content: center; align-items: center; border-radius: 12px; height: 52px; font-weight: 700; font-size: 14px; color: var(--color-main); ">참여중입니다.</div>
                            <div v-else @click.stop="confirmEnterJoin(memberList.join_way, memberList.password_hint)" style="flex: 1; background-color: #fff; display: flex; justify-content: center; align-items: center; border-radius: 12px; height: 52px; font-weight: 700; font-size: 14px; color: var(--color-main); ">참여하기</div>
                        </div>
                    </div>
                </transition>
            </div>
        </InteractionOfScale>
        <template v-if="isUseInnerPasswordModal">
            <MemberTalkPasswordInputModal :passwordHint="memberList.password_hint" :enterJoin="enterJoin" :isOpen="isOpenPasswordModal" :closeCompleteAction="closePasswordModal"></MemberTalkPasswordInputModal>
        </template>
    </div>
</template>

<script>
    import { JOIN_WAY, TEAM_TYPE } from '../../Constants';
    import IconHeart from './IconHeart.vue';
    import ProfileImage from './ProfileImage'
    import ResponseCode from '../../ResponseCode';
    import MemberTalkPasswordInputModal from "../modal/soccerjoin/MemberTalkPasswordInputModal";
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.min.css'
    import InteractionOfScale from '@/components/common/InteractionOfScale';
    import DivisionPositionText from '@/components/common/DivisionPositionText';

    const INVITATION_STATE = {
        PENDING: 0,
        APPROVE: 1
    }

    export default {
        name: "MemberTalkList",
        components: {
            MemberTalkPasswordInputModal,
            ProfileImage,
            IconHeart,
            swiper,
            swiperSlide,
            InteractionOfScale,
            DivisionPositionText
        },
        props: {
            memberList: {
                type: Object,
                default: () => { },
            },
            isInvitation: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: -1
            },
            completeAction: {
                type: Function,
                default: () => { }
            },
            openPasswordModal: {
                type: Function,
                default: () => { }
            },
            isUseInnerPasswordModal: {
                type: Boolean,
                default: false,
            },
            setLikeCnt: {
                type: Function,
                default: () => { }
            },
            isShowDong: {
                type: Boolean,
                default: false,
            },
            isShowMemberTalkFeed: {
                type: Boolean,
                default: false
            },
            joinMemberTalkConfirm: {
                type: Function,
                default: () => { }
            }
        },
        created() {
            this.enterJoin = this.$Once(this.enterJoin)
            this.approveInvitation = this.$Once(this.approveInvitation)
            // if (this.memberList.age) {
            //     this.memberList.age = this.memberList.age.split(',')
            // }
            //
            // if (this.memberList.join_tag) {
            //     this.memberList.join_tag = this.memberList.join_tag.split(',')
            // }

            this.like_yn = this.memberList.is_me_liked
            // console.log(this.memberList)

        },
        data() {
            return {
                TEAM_TYPE: TEAM_TYPE,
                swiperOption: {
                    slidesPerView: 'auto',
                    spaceBetween: 0, // swiper-slide 사이의 간격 지정
                    slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                    slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                    freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                    centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets'
                    },
                },
                JOIN_WAY: JOIN_WAY,
                join_tag: [],
                like_yn: '',
                showFormation: false,
                INVITATION_STATE: INVITATION_STATE,
                join_members: [],
                isOpenPasswordModal: false,
            };
        },
        methods: {
            async approveInvitation() {
                this.$GlobalStore.showProgress()
                const formData = new FormData()
                formData.append('join_idx', this.memberList.idx)
                formData.append('invitation_idx', this.memberList.invitation.idx)

                const res = await this.$Axios.post('/api/join/member/approve/invitation', formData)

                if (res.data.code === ResponseCode.SUCCESS) {
                    this.completeAction(this.index)
                    this.$GlobalStore.hideProgress()
                } else {
                    this.$GlobalStore.showAlert(res.data.msg)
                    this.$GlobalStore.hideProgress()
                }
            },
            async toggleLike(idx) {
                if (!this.$Util.checkLoginAndWeb()) {
                    return
                }

                let curLikeNumber = this.memberList.like_cnt

                if (this.like_yn) {
                    this.like_yn = false
                    curLikeNumber = '' + (parseInt(curLikeNumber) - 1)
                } else {
                    this.like_yn = true
                    curLikeNumber = '' + (parseInt(curLikeNumber) + 1)
                }

                this.setLikeCnt(curLikeNumber, this.index)

                const parameters = {}
                parameters.join_idx = idx
                parameters.is_like = this.like_yn ? '1' : '0'

                await this.$Axios.post('/api/join/like/toggle', parameters)
            },
            confirmEnterJoin(joinWay) {
                if (this.$Util.isShowDefaultSettings(false)) {
                    return
                }
                if (!this.$GlobalStore.loginInfo()) {
                    this.$GlobalStore.showLoginConfirm()
                    return
                }

                if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;

                if (joinWay === JOIN_WAY.ANYBODY) {
                    const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">멤버톡 참여하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>자유롭게 참여할 수 있는 멤버톡입니다.<br>멤버톡에 참여할까요?</div>`

                    this.$GlobalStore.showConfirm(html, () => {
                        this.enterJoin()
                        this.$Util.sendEventClick('멤버_참여하기')
                    }, '멤버톡 참여하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
                } else {
                    const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">멤버톡 참여하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>입장 코드를 입력하거나 매니저가 초대해야 참여할 수<br>있는 멤버톡입니다. 입장 코드를 입력해주세요</div>`

                    this.$GlobalStore.showConfirm(html, () => {
                        if (this.isUseInnerPasswordModal) {
                            this.isOpenPasswordModal = true;
                        } else {
                            this.openPasswordModal(this.memberList.idx, this.memberList.password_hint)
                            this.$Util.sendEventClick('멤버_비공개_참여하기')
                        }

                    }, '입력하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
                }
            },
            async enterJoin(password) {
                this.$GlobalStore.showProgress()
                const formData = new FormData
                formData.append('join_idx', this.memberList.idx);
                if (password) formData.append('password', password);
                const res = await this.$Axios.post('/api/join/member/apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

                this.$GlobalStore.hideProgress()
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.closePasswordModal();
                    this.completeAction(this.index)
                } else if (res.data.code === ResponseCode.FAIL) {
                    alert(res.data.msg)
                }
            },
            closePasswordModal() {
                this.isOpenPasswordModal = false;
            },
        },
    };
</script>

<style scoped>
    .fade-enter-active {
        transition: opacity 0.5s;
    }

    .fade-leave-active {
        transition: opacity 0.2s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .guide_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 12px;
        border-radius: 10px;
        background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%);
        position: relative;
        z-index: 9;
        margin-top: 12px;
        min-height: 100px;
        /* opacity: 1; */
        /* transition: all 0.5s; */
    }

    .triangle {
        border-top: 0px solid transparent;
        border-left: 0px solid transparent;
        border-right: 27px solid transparent;
        border-bottom: 20px solid #f5f5f5;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        content: "";
        position: absolute;
        top: -16px;
        left: 9%;
        transform: translateX(-50%);
    }

    .profile_circle {
        position: absolute;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), linear-gradient(0deg, #d9d9d9, #d9d9d9);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        top: 0;
        opacity: 0.5;
    }

    .see_my_profile {
        width: 20px;
        height: 20px;
        position: relative;
    }

    .see_my_profile img {
        width: 100%;
        height: 100%;
    }

    .tag_item {
        font-weight: 700;
        font-size: 10px;
        line-height: 14px;
        background-color: #fff;
        border-radius: 16px;
        padding: 4px 12px;
        white-space: nowrap;
    }

    .h_scroll_wrap {
        display: flex;
        gap: 4px;
        overflow-x: scroll;
        margin-left: -12px;
        padding-left: 12px;
        margin-right: -12px;
        padding-right: 12px;
    }

    .h_scroll_wrap::-webkit-scrollbar {
        display: none;
    }

    .swiper-pagination {
        position: absolute;
        bottom: 0px !important
    }

    .swiper-pagination>>>.swiper-pagination-bullet {
        background: #d9d9d9;
        width: 8px;
        height: 8px;
        opacity: 1;
        margin-left: 4px;
        margin-right: 4px;
    }

    .swiper-pagination>>>.swiper-pagination-bullet-active {
        background: var(--color-main);
    }
</style>
